const phoneToParams = (userInfo: any, phone: string, countryCode: string, country: string) => {
  const email = userInfo?.telecom.find((item: any) => item.system === 'email');
  return {
    resource: {
      resourceType: 'Patient',
      identifier: userInfo?.identifier,
      active: true,
      address: userInfo?.address,
      birthDate: userInfo.birthDate,
      gender: userInfo?.gender,
      name: userInfo?.name,
      avatar: userInfo.avatar,
      telecom: [
        email,
        {
          system: 'phone',
          value: phone,
          countryCode: countryCode,
          country: country,
        },
      ],
    },
  };
};

export default phoneToParams;
